import { Col, Row, Table, Tabs } from "antd";
import { useState } from "react";
import i18n from "../../../../../utils/i18n";
import "./dashboard-table.scss";

const columns = [
    {
        title: i18n.t("BBALMDashboard.objective"),
        dataIndex: "objective",
        key: "objective",
        width: 200,
        render: (text: string) => {
            return <div className='objective' >{text}</div>
        },
        fixed: 'left' as const,
    },
    {
        title: i18n.t("BBALMDashboard.existingDesc"),
        dataIndex: "existingDesc",
        key: "existingDesc",
        width: 350,
        render: (text: string) => {
            return <div className='existingDesc' >{text}</div>
        }
    },
    {
        title: i18n.t("BBALMDashboard.existingThreshold"),
        dataIndex: "existingThreshold",
        key: "existingThreshold",
        width: 300,
        render: (text: string) => {
            return <div className='existingThreshold' >{text}</div>
        }
    },
    {
        title: i18n.t("BBALMDashboard.apr2024Status"),
        dataIndex: "apr2024Status",
        key: "apr2024Status",
        render: (text: any) => {
            let activeValue
            let tabValue1
            let tabValue2
            let tabValue3
            let tabValue4

            if(text.className === 'red') {
                activeValue = "1"
                tabValue1 = text.value
                tabValue2 = ''
                tabValue3 = ''
                tabValue4 = ''
            }
            else if(text.className === "yellow") {
                activeValue = '2'
                tabValue1 = ''
                tabValue2 = text.value
                tabValue3 = ''
                tabValue4 = ''
            }
            else if(text.className === "light-green") {
                activeValue = '3'
                tabValue1 = ''
                tabValue2 = ''
                tabValue3 = text.value
                tabValue4 = ''
            }
            else if(text.className === "green") {
                activeValue = '4'
                tabValue1 = ''
                tabValue2 = ''
                tabValue3 = ''
                tabValue4 = text.value
            }
            

            return <div className={text.className} >
                <Tabs defaultActiveKey={activeValue}>
                    <Tabs.TabPane tab={tabValue1} key="1" />
                    <Tabs.TabPane tab={tabValue2} key="2" />
                    <Tabs.TabPane tab={tabValue3} key="3" />
                    <Tabs.TabPane tab={tabValue4} key="4" />
                </Tabs>
            </div>
        }
    },
    {
        title: i18n.t("BBALMDashboard.may2024Status"),
        dataIndex: "may2024Status",
        key: "may2024Status",
        render: (text: any) => {
            let activeValue
            let tabValue1
            let tabValue2
            let tabValue3
            let tabValue4

            if(text.className === 'red') {
                activeValue = "1"
                tabValue1 = text.value
                tabValue2 = ''
                tabValue3 = ''
                tabValue4 = ''
            }
            else if(text.className === "yellow") {
                activeValue = '2'
                tabValue1 = ''
                tabValue2 = text.value
                tabValue3 = ''
                tabValue4 = ''
            }
            else if(text.className === "light-green") {
                activeValue = '3'
                tabValue1 = ''
                tabValue2 = ''
                tabValue3 = text.value
                tabValue4 = ''
            }
            else if(text.className === "green") {
                activeValue = '4'
                tabValue1 = ''
                tabValue2 = ''
                tabValue3 = ''
                tabValue4 = text.value
            }
            

            return <div className={text.className} >
                <Tabs defaultActiveKey={activeValue}>
                    <Tabs.TabPane tab={tabValue1} key="1" />
                    <Tabs.TabPane tab={tabValue2} key="2" />
                    <Tabs.TabPane tab={tabValue3} key="3" />
                    <Tabs.TabPane tab={tabValue4} key="4" />
                </Tabs>
            </div>
        }
    },
];

const DashboardTable = () => {
    const [data, setData] = useState([
        {
            id: 1,
            objective: "Significant Increase in Credit Risk",
            existingDesc:
                "On Quarterly Basis Downgrades from Stage 1 - Stage 2/Corporate Loan Portfolio",
            existingThreshold: "Not greater than 1.5% (annual)",
            apr2024Status: {
                value: "0.27%",
                className: "green"
            },
            may2024Status: {
                value: "0.33%",
                className: "green"
            },
        },
        {
            id: 2,
            objective: "Expected Credit Loss Coverage Ratio",
            existingDesc:
                "ECL reserves to NPL’s (RR10~12)",
            existingThreshold: "Not lower than 110%",
            apr2024Status: {
                value: "154.8%",
                className: "green"
            },
            may2024Status: {
                value: "169.8%",
                className: "green"
            },
        },
        {
            id: 3,
            objective: "Liquidity Coverage ratio (LCR)**",
            existingDesc:
                "The LCR builds on traditional liquidity “coverage ratio” methodologies used internally by banks to assess exposure to short term (less than 1 month) contingent liquidity demands.",
            existingThreshold: "Not lower than 100%",
            apr2024Status: {
                value: "383%",
                className: "green"
            },
            may2024Status: {
                value: "246%",
                className: "green"
            },
        },

        {
            id: 4,
            objective: "Liquidity Ratio",
            existingDesc:
                "Liquidity ratio indicates extent to which current (short term) liabilities are covered by available current assets. Regulatory Liquidity Ratio target is minimum at 20% and the Bank is targeted to maintain it at greater or equal to 22%.",
            existingThreshold: "Not lower than 22%",
            apr2024Status: {
                value: "27.2%",
                className: "green"
            },
            may2024Status: {
                value: "22.60%",
                className: "yellow"
            },
        },

        {
            id: 5,
            objective: "Liquidity Crisis Scenario",
            existingDesc:
                "Liquefiable Assets(LA) should cover at least 100% of liquid liabilities in 30 days.(ALCO Methodology is 100% of LA75%)",
            existingThreshold: "Based on ALCO Methodology - Not lower than 100%",
            apr2024Status: {
                value: "113%",
                className: "light-green"
            },
            may2024Status: {
                value: "109%",
                className: "light-green"
            },
        },

        {
            id:6,
            objective: "Loan to Deposit ratio",
            existingDesc:
                "A 1% change in interest rates not to exceed [6%] of the last 4 Quarters net interest income. (Target is subject to change Quarterly)",
            existingThreshold: "Not greater than $296 Million",
            apr2024Status: {
                value: "210",
                className: "green"
            },
            may2024Status: {
                value: "156",
                className: "green"
            },
        },

        {
            id: 7,
            objective: "Net Interest Income at Risk",
            existingDesc:
                "Total loans divided by total deposits indicates the extent to which the bank has used available deposit (including sukuk) funds to extend Credit. (Regulatory guideline is ≤85% )",
            existingThreshold: "Not greater than 85%",
            apr2024Status: {
                value: "81.4%",
                className: "yellow"
            },
            may2024Status: {
                value: "84.1%",
                className: "yellow"
            },
        },

    ]);

    return (
        <div className="dashboard-table-wrapper">
            <Row>
                <Col span={24}>
                    <Table
                        scroll={{ x: 1360 }}
                        loading={false}
                        dataSource={data}
                        pagination={false}
                        columns={columns}
                        rowKey="id"
                    />
                </Col>
            </Row>
        </div>
    );
};

export default DashboardTable;
